<ion-row class="iti-row">
    <ion-col size="3" class="iti-col">
        <p class="iti-dates">
            {{ itineraryItem?.saved_selected_date?.session }}
        </p>
        <ion-buttons>
            <ion-button fill="outline" color="secondary" class="iti-button" (click)="updateDate()"> Change Dates </ion-button>
        </ion-buttons>
        <ion-select
            placeholder="Change Dates"
            interface="alert"
            [interfaceOptions]="customAlertOptions"
            [(ngModel)]="savedItem.display"
            class="sneaky-change-dates"
            (ionChange)="changeDates($event)"
        >
            <ion-select-option *ngFor="let time of rows" [value]="time">
                {{ time?.display }}
            </ion-select-option>
        </ion-select>
    </ion-col>

    <ion-col size="3" class="iti-col iti-relative">
        <div class="iti-lead" [ngClass]="{ 'even-background': !(index % 2) }">
            <fa-icon [icon]="iconOfiti" size="lg"></fa-icon>
        </div>
        <div class="iti-border">
            <a class="program-link" (click)="goToProgram(itineraryItem?.programid)">
                {{ itineraryItem?.programname }}
            </a>
        </div>
    </ion-col>

    <ion-col size="2" class="iti-col ion-text-center">
        <p class="dark-teal">
            {{ itineraryItem?.type }}
        </p>
    </ion-col>

    <ion-col size="2" class="iti-col ion-text-center">
        <p class="dark-teal">
            <span><fa-icon [icon]="faMapMarkerAlt"></fa-icon></span>{{ itineraryItem?.location }}
        </p>
    </ion-col>

    <ion-col size="1" class="iti-col ion-text-center">
        <p>${{ itineraryItem?.price }} USD</p>
    </ion-col>

    <!-- <ion-col size="1" class="iti-col ion-text-center">
        <p>placeholder</p>
    </ion-col> -->

    <ion-col size="1" class="iti-col">
        <ion-button class="iti-button warning-btn" expand="block" fill="clear" shape="round" (click)="removeFromItinerary()"> Remove </ion-button>
    </ion-col>
</ion-row>
